<script setup>
import ModalConsent from "./ModalConsent";
import ApplyConsent from "./ApplyConsent";

const props = defineProps({
  open: { type: Boolean, default: false },
  application: { type: String, required: true },
});
const emit = defineEmits(["close"]);

const close = () => {
  emit("close", false);
};
</script>
<template>
  <ModalConsent @close="close" :open="open">
    <ApplyConsent :application="application" :open="open" @close="close" />
  </ModalConsent>
</template>
